// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__u1mGw","additionalInfo":"AgreementModal_additionalInfo__qH0TY"};